<template>
    <div>
        <scrolling-gallery-thumbnails v-if='carousel' :gallery='gallery' @selectImage='selectImage' :color='color'></scrolling-gallery-thumbnails>
        <gallery-thumbnails :direction='direction' v-else :gallery='gallery' @selectImage='selectImage' :color='color'></gallery-thumbnails>
        

        <div class='imagePopover' v-if='showPopover' @click.self='showPopover = false'>
            <div @click='prevImage'><img class='imageButton' :src="require('../assets/arrow-left.svg').default"></div>
            <div class='imagePopoverContent'>
                <div v-if='isImage(selectedImage)' class='imageContainer'>
                <img  :class="isPortrait(selectedImage)? 'portrait' : 'landscape' " :src='selectedImage.image.url'>
                </div>
                <object v-else class='pdfviewer' type="application/pdf" :data="selectedImage.image.filename"></object>
                <div v-if='selectedImage.caption !== ""' class='imageCaption' v-html='selectedImage.caption'></div>
            </div>
            <div @click='nextImage'><img class='imageButton' :src="require('../assets/arrow-right.svg').default"></div>
        </div>
    </div>
</template>

<script>
import ScrollingGalleryThumbnails from './ScrollingGalleryThumbnails'
import GalleryThumbnails from './GalleryThumbnails';

export default {
    name: 'image-gallery',
    props: {
        gallery: { type: Array }, 
        carousel: { type: Boolean, default: false },
        color: { default: 'cs-moss' },
        direction: { default: 'horizontal' }
    },
    data() {
        return {
            selectedImage: {},
            showPopover: false,
            currentIndex: 0
        }
    },
    methods: {
        selectImage(index) {
            this.currentIndex = index;
            this.selectedImage = this.gallery[this.currentIndex];
            this.showPopover = true;
        },
        nextImage(e) {
            this.currentIndex = (this.currentIndex+1) % (this.gallery.length);
            this.selectedImage = this.gallery[this.currentIndex];
            e.preventDefault();
        },
        prevImage(e) {
            this.currentIndex = (this.currentIndex+this.gallery.length-1) % (this.gallery.length);
            this.selectedImage = this.gallery[this.currentIndex];
            e.preventDefault();
        },
        isPortrait(image) {
            return image.image.height > image.image.width;
        },
        isImage(image) {
            return image.image.type == 'Image';
        }
    },
    components: {
        'scrolling-gallery-thumbnails': ScrollingGalleryThumbnails,
        'gallery-thumbnails': GalleryThumbnails
    }
}
</script>


<style lang='less'>

.imagePopover {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;

    .imageButton {
        height: 50px;
    }

    .pdfviewer {
        width: 90vw;
        height: 90vh;
    }

    .imagePopoverContent {
        position: relative;
        
        text-align: center;
    }

    .imageContainer {
        max-width:90vw;
        height: 90vh;
    }

    img {
        object-fit: contain;
        height:100%;
        max-width: 100%;
    }

    .imageCaption {
        color: white;
        text-align: left;
        font-weight: bold;
        position: absolute;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        width: 100%;
        padding: 10px;

        p:last-child {
            margin-bottom: 0;
        }
    }
}
</style>